// src/services/notificationService.js
// Frontend-only helper (React). ŽÁDNÉ Node importy (undici apod.)!

const DEFAULT_DEV_FUNCTIONS = "http://127.0.0.1:9998";

/**
 * Určí base URL pro Netlify Functions.
 * - pokud nastavíš REACT_APP_NETLIFY_FUNCTIONS_URL, použije se vždy (např. https://xxx.netlify.app)
 * - v development:
 *    - pokud jedeš přes "netlify dev" (typicky port 8888), použijeme relativní cestu (same-origin)
 *    - jinak použijeme DEFAULT_DEV_FUNCTIONS (netlify functions:serve --port 9998)
 * - v production: relativní cesta (same-origin na Netlify)
 */
function getFunctionsBase() {
  const env = (process.env.REACT_APP_NETLIFY_FUNCTIONS_URL || "").trim();
  if (env) return env.replace(/\/$/, "");

  const isDev = process.env.NODE_ENV === "development";

  if (isDev) {
    // Pokud jedeš přes `netlify dev`, FE i functions jsou same-origin (port 8888)
    const port = window?.location?.port;
    if (port === "8888") return ""; // same-origin -> "/.netlify/functions/..."
    return DEFAULT_DEV_FUNCTIONS; // `netlify functions:serve --port 9998`
  }

  return ""; // production on Netlify -> "/.netlify/functions/..."
}

const FUNCTIONS_BASE = getFunctionsBase();

async function safeReadText(res) {
  try {
    return await res.text();
  } catch {
    return "";
  }
}

export const notifySlack = async (userData) => {
  const url = `${FUNCTIONS_BASE}/.netlify/functions/notifyNewUser`;

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });

    if (!res.ok) {
      const text = await safeReadText(res);
      console.error(
        `❌ Slack notifyNewUser selhalo (${res.status}) ${res.statusText}\nURL: ${url}\nResponse: ${text}`,
      );
      return false;
    }

    console.log("✅ Slack notifikace odeslána:", url);
    return true;
  } catch (error) {
    console.error("❌ Nepodařilo se odeslat notifikaci na Slack:", error);
    console.error("URL:", url);
    return false;
  }
};
